
declare const customscripts: { nonce: string };
class HeaderPrimary {
  private body: HTMLElement = document.body;

  // Popin 
  private openPopinTriggers: NodeListOf<HTMLElement>;
  private popinContent: HTMLElement | null;
  private closePopinTriggers: NodeListOf<HTMLElement>;
  private popinOverlay: HTMLElement | null;

  // Port
  private portItems?: NodeListOf<HTMLElement>;
  private storageKey: string = 'selectedPort';

  // Menu
  private menuButton: HTMLButtonElement | null;
  private menuPanel: HTMLElement | null;
  private menuCloseTriggers: NodeListOf<HTMLElement>;
  private menuOverlay: HTMLElement | null;

  constructor() {
    // Popin 
    this.openPopinTriggers = document.querySelectorAll('[data-popin-ports-open]');
    this.popinContent = document.querySelector('[data-popin-ports-content]');
    this.closePopinTriggers = document.querySelectorAll('[data-popin-ports-close]');
    this.popinOverlay = document.querySelector('[data-popin-ports-overlay]');

    // Menu
    this.menuButton = document.querySelector('[data-header-menu-btn]');
    this.menuPanel = document.querySelector('[data-header-menu]');
    this.menuCloseTriggers = document.querySelectorAll('[data-header-menu-close]');
    this.menuOverlay = document.querySelector('[data-header-menu-overlay]');

    if (this.openPopinTriggers && this.popinContent) {
      // Port
      this.portItems = this.popinContent.querySelectorAll('[data-popin-ports-item]');
      this.initPopinEvents();
      this.saveSelectedPort();
    }

    this.initMenuEvents();
  }

  // Popin
  private initPopinEvents(): void {
    this.openPopinTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.openPopin();
      });
    });


    this.closePopinTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.closePopin();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closePopin();
      }
    });
  }

  private openPopin(): void {
    // Fermeture du menu si ouvert
    this.closeMenu();
    this.popinContent!.classList.add('active');
    this.popinOverlay?.classList.add('active');
    this.body.classList.add('unscrollable');
  }

  private closePopin(): void {
    this.popinContent!.classList.remove('active');
    this.popinOverlay?.classList.remove('active');
    this.body.classList.remove('unscrollable');
  }

  // Port
  private saveSelectedPort(): void {
    if (!this.portItems)
      return
    this.portItems.forEach(item => {
      item.addEventListener('click', async () => {

        const selectedSlug = item.dataset.value;
        if (!selectedSlug) return;

        localStorage.setItem(this.storageKey, selectedSlug);
        const response = await fetch('/wp-json/haropa/v1/set-port-cookie', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': customscripts.nonce
          },
          body: JSON.stringify({ port_slug: selectedSlug })
        });

        if (!response.ok) {
          throw new Error('La réponse du serveur n\'est pas OK');
        }
        const redirectUrl = `${window.location.origin}/${selectedSlug}/accueil`;

        // console.log(`Port sauvegardé : ${selectedSlug}`);
        // console.log(`Redirection vers : ${redirectUrl}`);

        window.location.href = redirectUrl;
      });
    });
  }

  // Menu
  private initMenuEvents(): void {
    if (!this.menuButton || !this.menuPanel) {
      return;
    }

    this.menuButton.addEventListener('click', () => {
      this.toggleMenu();
    });

    this.menuCloseTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.closeMenu();
      });
    });
  }



  private toggleMenu(): void {
    const isActive = this.menuPanel?.classList.contains('active');
    if (isActive) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  private openMenu(): void {
    if (!this.menuButton || !this.menuPanel) return;

    this.menuButton.setAttribute('aria-expanded', 'true');
    this.menuButton.classList.add('active');
    this.menuPanel.classList.add('active');
    this.menuOverlay?.classList.add('active');
    this.body.classList.add('unscrollable');
  }

  // NOUVEAU : Méthode dédiée à la fermeture
  private closeMenu(): void {
    if (!this.menuButton || !this.menuPanel) return;

    this.menuButton.setAttribute('aria-expanded', 'false');
    this.menuButton.classList.remove('active');
    this.menuPanel.classList.remove('active');
    this.menuOverlay?.classList.remove('active');
    this.body.classList.remove('unscrollable');
  }
}

export const headerPrimary = new HeaderPrimary();
